import insurance from './insurance.svg';

export default function InsuranceIcon() {
  return <img src={insurance} alt={'insurance'} width="32" height="32" />;
}
